export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export function isEmptyGuid(guid) {
    return !guid || guid === EMPTY_GUID;
}
